"use client";

import { Icon } from "@/components/ui/icon";

interface JobCloneNoticeProps {
  sourceName: string | null;
  className?: string;
}

export function JobCloneNotice({ sourceName, className }: JobCloneNoticeProps) {
  const label = sourceName ?? "this job";

  return (
    <div
      className={`flex shrink-0 items-start gap-2 rounded-md border border-primary/10 bg-primary/10 px-3 py-2.5 backdrop-blur-[2px] ${className ?? ""}`}
    >
      <Icon
        name="IconFiles"
        size={14}
        className="mt-0.5 shrink-0 text-primary dark:text-[#bccdff]"
      />
      <p className="min-w-0 flex-1 text-[13px] leading-[18px] tracking-[-0.26px] text-primary dark:text-[#bccdff]">
        Cloning{" "}
        <span className="font-medium break-words" title={label}>
          {label}
        </span>
        . Pre-filled from the source — review each step before creating.
      </p>
    </div>
  );
}
